
export class WebsocketTools {

  static parseTopicParts(topic?: string): { organization?: string; site?: string } {
    if (!topic) {
      return {};
    }

    const organizationMatch = topic.match(/organization_([^.]+)/);
    const siteMatch = topic.match(/site_([^.]+)/);

    return {
      organization: organizationMatch?.[1],
      site: siteMatch?.[1]
    };
  }

}
